export default class Chart {

    constructor($object) {

        const that = this;
        this.$object = $object;

        var imagesCount = $object.find('img:visible').length,
            loadedImages = 0;

        $object.find('img').on('load', function(e) {
            loadedImages++;

            if (loadedImages >= imagesCount) {
                that.init();
            }
        });

        this.resizeTimer = null;

        $(window).on('resize', function() {
            clearInterval(that.resizeTimer);
            setTimeout(that.init.bind(that), 300);
        });
    }

    init() {

        const that = this;
//console.log('chart init', this);
        if (!this.$object) {
            debugger;
        }

        this.$object.removeClass('animation-inited');

        // reset old presets
        this.$object.css({'height': 'auto'});
        this.$object.find('.js-chart-fixed-height').css({'height': 'auto'});
        this.$object.find('.js-chart-image').width('100%');
        this.$object.find('.js-chart-holder').width('100%');

        // set height & width
        this.height = this.$object.height() << 0;

        this.$object.css({'height': this.height});
        this.$object.find('.js-chart-fixed-height').css({'height': this.height});

        this.$object.find('.js-chart-image:visible').each(function(i, img) {
            var $img = $(img),
                $holder = $img.closest('.js-chart-holder'),
                width = $img.width() << 0;

            $img.width(width);
            $holder.width(width);
        });

        setTimeout(function() {
            that.$object.addClass('animation-inited');
        }, 200);
    }
}